class CollectionLoadingButton extends HTMLElement
{
	constructor() {
		super();
	}

	fetchData(cb = null) {
		const productGrid = document.getElementById(this.dataset.productGrid);
		productGrid.parentElement.classList.add('loading');
		fetch(`${this.dataset.url}`, {method: 'GET'})
		.then((response) => {
			return response.text();
		})
		.then(responseText => {
			productGrid.parentElement.classList.remove('loading');
			const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
			let responseProductItems = responseHTML.querySelectorAll(`#${this.dataset.productGrid} > *`);
			
			if(responseProductItems.length > 0) {
				if(this.dataset.loadingType == 'next') {
					responseProductItems.forEach(element => {
						productGrid.appendChild(element);
					});
				} else {
					Array.from(responseProductItems).reverse().forEach(element => productGrid.prepend(element));
				}
				if(window.appearAnimate) {
					const appear_animate_list = this.closest('appear-animate-list');
					if(appear_animate_list) {
						appear_animate_list.reset();
					}
				}
			}

			const newButton = responseHTML.querySelector(`.collection__loading-button[data-loading-type="${this.dataset.loadingType}"]`);
			if(newButton) {
				if(this.dataset.loadingType == 'next') {
					this.parentElement.appendChild(newButton);
				} else {
					this.parentElement.prepend(newButton);
				}
			}

			// Keep the collection URL on the first page; loaded products remain appended.

			this.remove();

			if(cb) {
				cb();
			}
		})
		.catch(e => {
			productGrid.parentElement.classList.remove('loading');
		});
	}
}

class CollectionInfiniteButton extends CollectionLoadingButton
{
  connectedCallback() {
		let observer = new IntersectionObserver((entries, observer) => {
			if(entries[0].isIntersecting) {
				this.fetchData();
				observer.disconnect();
			}
		});

		observer.observe(this);
	}
}

customElements.define('collection-infinite-button', CollectionInfiniteButton);

class CollectionLoadMoreButton extends CollectionLoadingButton
{
	connectedCallback() {
		this.addEventListener('click', this.onClick);
	}

	onClick() {
		this.removeEventListener('click', this.onClick);
		this.fetchData();
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.onClick);
	}
}

customElements.define('collection-load-more-button', CollectionLoadMoreButton);

/* Restore an expanded collection when returning from a product page. */
(() => {
  if (window.avilaCollectionMemory) return;
  window.avilaCollectionMemory = true;
  const prefix = 'avila:collection:v1:';
  const key = prefix + location.pathname + location.search;
  const grid = () => document.getElementById('product-grid');
  function save() {
    const list = grid();
    if (!list) return;
    const next = document.querySelector('collection-load-more-button[data-loading-type="next"]');
    const data = JSON.stringify({html: list.innerHTML, count: list.children.length,
      next: next ? next.outerHTML : '', y: scrollY, saved: Date.now()});
    try {
      for (let i = sessionStorage.length - 1; i >= 0; i--) {
        const old = sessionStorage.key(i);
        if (old.startsWith(prefix) && old !== key) sessionStorage.removeItem(old);
      }
      sessionStorage.setItem(key, data);
    } catch (_) {}
  }
  function restore() {
    const list = grid();
    if (!list) return;
    const navigation = performance.getEntriesByType('navigation')[0];
    let fromProduct = false;
    try { fromProduct = new URL(document.referrer).origin === location.origin &&
      new URL(document.referrer).pathname.includes('/products/'); } catch (_) {}
    if (navigation?.type !== 'back_forward' && !fromProduct) return;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(key)); } catch (_) { return; }
    if (!saved || Date.now() - saved.saved > 1800000 || saved.count <= list.children.length) return;
    list.innerHTML = saved.html;
    const next = document.querySelector('collection-load-more-button[data-loading-type="next"]');
    if (next) {
      if (saved.next) {
        const restored = new DOMParser().parseFromString(saved.next, 'text/html').body.firstElementChild;
        next.replaceWith(restored);
      } else next.remove();
    }
    const animations = list.closest('appear-animate-list');
    if (window.appearAnimate && animations) animations.reset();
    requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, saved.y)));
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('#product-grid a[href]');
    if (link && link.getAttribute('href').includes('/products/')) save();
  }, true);
  addEventListener('pagehide', save);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, {once:true});
  else restore();
})();

